import {Injectable} from '@angular/core';
import {SpotfightUser} from "../core/models/models";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) {
  }

  async fetchCurrentUser(): Promise<SpotfightUser> {
    return firstValueFrom(this.httpClient.get<SpotfightUser>(environment.apiUrl + "users/profile"));
  }

  async unlinkUser(): Promise<SpotfightUser> {
    return firstValueFrom(this.httpClient.put<SpotfightUser>(environment.apiUrl + "users/unlink", {}));
  }

}
